import AzureExtractFeed from './AzureExtractFeed'

export default function MeterFeed() {
  return <AzureExtractFeed feedId="meter" />
}
